import {
  createContext,
  useState,
  useEffect,
  useCallback,
  useContext,
  useMemo
} from 'react';
import React from 'react';
import * as MVOapi from '../Api/MVO';
export const MVOContext = createContext();
export const useMVO = () => useContext(MVOContext);

export const MVOProvider = ({
  children
}) => {
  const [initialLoad, setInitialLoad] = useState(false);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const [MVO, setMVO] = useState([]);
  const [MVOid, setMVOid] = useState({});
  const [MVOSDGID, setMVOSDGID] = useState({});
  const [MVOTargetID, setMVOTargetID] = useState({});

  const refreshMVO = useCallback(async() => {
    if(localStorage.getItem("auth_token") !== null){
      try {
          setError();
          setLoading(true);
          const data = await MVOapi.getAllMVO();
          setMVO(data);
          return data;
      } catch (error) {
          setError(error);
      } finally {
          setLoading(false)
      }
    }
  }, []);




  useEffect(() => {
      if (!initialLoad) {
            refreshMVO();
            setInitialLoad(true);
        }
  }, [initialLoad, refreshMVO]);


  const getMVObyID = useCallback(async(id) => {
    try {
        setError();
        setLoading(true);
        const data = await MVOapi.getMVObyID(id);
        setMVOid(data);
        return data;
    } catch (error) {
        setError(error);
    } finally { 
        setLoading(false)
    }

  }, []);

  const getMVObySDGID = useCallback(async(id) => {
    try {
        setError();
        setLoading(true);
        const data = await MVOapi.getMVObySDGID(id);
        setMVOSDGID(data);
        return data;
    } catch (error) {
        setError(error);
    } finally { 
        setLoading(false)
    }

  }, []);

  const getMVObyTargetID = useCallback(async(id) => {
    try {
        setError();
        setLoading(true);
        const data = await MVOapi.getMVObyTargetID(id);
        setMVOTargetID(data);
        return data;
    } catch (error) {
        setError(error);
    } finally { 
        setLoading(false)
    }

  }, []);


  const createMVO = useCallback(async(data) => {
    setError();
    setLoading(true);  
    try {
        const response = await MVOapi.createMVO(data);
        await refreshMVO();
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    } finally {
        setLoading(false)
    }
}, [refreshMVO]);


const updateChartType = useCallback(async(mvoID,charttype) => {
    try {
      setError();
      setLoading(true);
      await MVOapi.updateMVOCharttype(mvoID,charttype)
      refreshMVO();
    } catch (error) {
      setError(error);
  } finally {
      setLoading(false)
  }
  },[refreshMVO])

  const value = useMemo(() => ({
     refreshMVO,
      MVO,
      error,
      loading,
      MVOid,
      MVOSDGID,
      MVOTargetID,
      getMVObyID,
      getMVObySDGID,
      getMVObyTargetID,
      createMVO,
      updateChartType
  }), [refreshMVO,MVO, error, loading,MVOid,MVOSDGID,MVOTargetID,getMVObySDGID,getMVObyID,getMVObyTargetID,createMVO,updateChartType]);

  return ( <MVOContext.Provider value = {value} > {
          children
      } </MVOContext.Provider>
  );
};